import iframe from '@ps/bridge/iframe/iframe'
import i18n from '@ps/lang'

export default {
  namespaced: true,

  state: {
    dialog: {
      visible: false
    },
    onCrop: null, // 裁剪后回调时间
    url: null,
    cache: null,
    clipStartTime: 0, // 裁剪开始时间，单位毫秒
    clipEndTime: 0, // 裁剪结束时间，单位毫秒
    duration: 0,
    loading: false
  },

  mutations: {
    openDialog(state, { url, onCrop, clipStartTime, clipEndTime, duration } = {}) {
      if (!url) throw new Error(i18n.t('workbench.video.videoEditor.argumentsAreEmpty'))
      state.dialog.visible = true
      state.url = url
      state.clipStartTime = clipStartTime
      state.clipEndTime = clipEndTime
      state.duration = duration
      state.loading = false
      onCrop && (state.onCrop = onCrop)
      // 暂停所有声音
      iframe.stopAllSound()
    },

    closeDialog(state) {
      state.dialog.visible = false
      state.onCrop = null
      state.url = ''
      state.clipStartTime = -1
      state.clipEndTime = -1
      state.duration = -1
      state.loading = false
      // 恢复所有声音
      iframe.recoveryAllSound()
    },

    setLoading(state, loading) {
      state.loading = loading
    }
  },

  actions: {
  }
}
